import { getCountry, getWithDotComByCountry } from '@/utils';

export const enum envTypes {
  prod,
  hom,
  dev,
  local,
  internal,
  refactory,
}

const country = getCountry();
const withCom = getWithDotComByCountry(country);

const getEnvironment = (domain: string): { env: envTypes; domain: string } => {
  const dic: Array<{env: envTypes, domain: string}> = [
    {env: envTypes.prod, domain: `cp.neogig${withCom}${country}`},
    {env: envTypes.hom, domain: `cp.qa.neogig${withCom}${country}`},
    {env: envTypes.dev, domain: `cp.dev.neogig${withCom}${country}`},
    {env: envTypes.local, domain: `localhost`},
    {env: envTypes.internal, domain: `cp.internal.neocom`},
    {env: envTypes.refactory, domain: `cp.refactory.neogig${withCom}${country}`},
  ];

  return dic.find((x) => domain.toLowerCase().indexOf(x.domain) > -1) || dic[0];
};

const {hostname} = location;
export const env: envTypes = getEnvironment(hostname).env;
export const neoPvcProcessUrl = 'http://pvc.internal.neocom/hangfire';
